import React from 'react';
import { DialogModal, Typography } from '@up-riac/bespoke-ui';
import { BirthdayVerifier } from 'src/components/AgeVerificationCheck/BirthdayVerifier';


export type AgeVerificationCheckProps = {
  isOpen?: boolean,
  onValidDate?: () => void,
  onInvalidDate?: () => void,
};

export const AgeVerificationCheck = (props: AgeVerificationCheckProps): JSX.Element => {
  return (
    <DialogModal
      isOpen={true}
      onClose={() => {
        // No-op. Force user to verify age
      }}
      id='age-verification-dialog'
      dialogClassname='max-w-[464px]'
    >
      <DialogModal.Header title='Age Verification'/>
      <DialogModal.Content>
        <div className='flex flex-col gap-3'>
          <Typography>
            Welcome to Rock Island Auction,
          </Typography>
          <Typography>
            This website contains content intended for individuals who are 18 years of age or older.
            By entering this website, you affirm that you understand and comply with the age restrictions in place.
            If you are not of legal age to access such content,
            we kindly request that you exit the site immediately.
          </Typography>
          <Typography>
            Thank you for respecting our guidelines and policies.
          </Typography>
          <Typography>
            <Typography>
              Best regards,
            </Typography>
            <Typography>
              Rock Island Auction Company
            </Typography>
          </Typography>
        </div>
      </DialogModal.Content>
      <DialogModal.Footer>
        <div className='flex flex-row justify-center p-4 bg-surface-dark dark:bg-surface-darker'>
          <BirthdayVerifier
            onValidDate={() => {
              if(props.onValidDate) {
                props.onValidDate();
              } else {
                window.localStorage.setItem('ageVerified', 'true');
              }
            }}
            onInvalidDate={() => {
              if(props.onInvalidDate) {
                props.onInvalidDate();
              } else {
                window.location.href = 'https://www.google.com';
              }
            }}
          />
        </div>
      </DialogModal.Footer>
    </DialogModal>
  );
};
